module.exports = __webpack_public_path__ + "static/media/materiePrime.3381af4f.jpg";